const ADDRESS_ALLOWED_CHAR_PATTERN = /[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑýÝ .:,/'-]/;

type AddressMaskFactory = ((value?: string) => string) & {
  patterns: {
    X: {
      pattern: RegExp;
    };
  };
};

export const AddressMask: AddressMaskFactory = Object.assign(
  () => 'X*',
  {
    patterns: {
      X: {
        pattern: ADDRESS_ALLOWED_CHAR_PATTERN,
      },
    },
  }
);
